module.exports = __webpack_public_path__ + "static/media/shanzelize Still 7-mobile.173a16c0.webp";